export default __webpack_public_path__ + "static/comparisons-team-6808509689f4e2cb92090be20d1da190.webp";